import * as CommonActions from "./common"

export const ActionCreators = Object.assign({},
    CommonActions
);

export default ActionCreators;